import {IndustryType} from "./product";

export {IndustryType};

export const INDUSTRY_TYPES: { value: IndustryType; label: string }[] = [
    {value: IndustryType.MEDICAL_WELLNESS, label: 'Medical & Wellness'},
    {value: IndustryType.REAL_ESTATE, label: 'Real Estate'},
    {value: IndustryType.LEGAL_SERVICES, label: 'Legal Services'},
    {value: IndustryType.OTHER, label: 'Other'},
];

export interface VoiceTrainingScriptDTO {
    id?: string;
    title?: string;
    industry_type?: IndustryType;
    language?: string;
    organization_id?: string;
    content?: string;
    created_at?: string;
    updated_at?: string;
}
